export default {
    en: {
        id: 'diagram3b4-3',
        blocks: [
            {
                task: 'S = Open plan office sought to boost communication and efficiency, deemphasize status',
                answer: 'Did A to get B and C',
                title: "S = ",
                modelName: 's'
            },
            {
                task: 'C = Study showed that employees disliked it on every aspect measured',
                answer: 'Caused problems',
                title: "C = ",
                modelName: 'c'
            },
            {
                task: 'Q = (How respond?)',
                answer: '(How fix?)',
                title: "Q = ",
                modelName: 'q'
            },
            {
                task: 'A = Restored privacy',
            }
        ],
        subtitle: 'Fill in the SCQ boxes substituting Xs and Ys, etc. for specific nouns. Then press "simplest structure" and compare your answers',
        correctAnswers: 3
    }
}



// WEBPACK FOOTER //
// ./client/app/modules/courses/4/4a/practiceInSeeing/i18n/exercise3.js